import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { UserInfoData } from '@/network/api/user/type'
import { clearTokens } from '@/network/tokenManager'
import { useCustomerContextStore } from '@/store/customerContext'
// interface UserStore {
//   userInfo: object | null
//   token: string
//   setUserInfo: (userObj: object) => void
//   setToken: (token: string) => void
//   resetUser: () => void
// }

type State = {
  userInfo: UserInfoData
  token: string
}

type Actions = {
  setUserInfo: (userObj: UserInfoData) => void
  setToken: (token: string) => void
  resetUser: () => void
}

const initialState: State = {
  userInfo: {
    id: 0,
    phone: '',
    username: '',
    email: '',
    birthday: '',
    gender: '',
    avatar: '',
  },
  token: '',
}

export const useUserStore = create<State & Actions>()(
  persist(
    (set) => ({
      ...initialState,
      setUserInfo: (userObj: UserInfoData) => {
        // 使用cookie存储user_id
        const isHttpsEnabled = import.meta.env.VITE_HTTPS_STATE === 'true'
        // 根据VITE_HTTPS_STATE判断是否使用安全设置
        const cookieOptions = isHttpsEnabled
          ? '; path=/; secure; sameSite=strict' // HTTPS环境使用安全设置
          : '; path=/' // HTTP环境使用基础设置
        document.cookie = `user_id=${userObj?.id?.toString() ?? ''}; expires=${new Date(Date.now() + 365 * 864e5).toUTCString()}${cookieOptions}`
        set({ userInfo: userObj })
      },
      setToken: (token) => {
        // 使用cookie存储token
        const isHttpsEnabled = import.meta.env.VITE_HTTPS_STATE === 'true'
        // 根据VITE_HTTPS_STATE判断是否使用安全设置
        const cookieOptions = isHttpsEnabled
          ? '; path=/; secure; sameSite=strict' // HTTPS环境使用安全设置
          : '; path=/' // HTTP环境使用基础设置
        document.cookie = `token=${token}; expires=${new Date(Date.now() + 365 * 864e5).toUTCString()}${cookieOptions}`
        set(() => ({ token }))
      },
      resetUser: () => {
        // 清除所有 token 存储（cookie + localStorage，含 refreshToken）
        clearTokens()
        useCustomerContextStore.getState().reset()
        set(() => ({ userInfo: initialState.userInfo, token: '' }))
      },
    }),
    {
      partialize: (state) => ({
        token: state.token,
        userInfo: state.userInfo,
      }),
      name: 'tokenStore',
      onRehydrateStorage: () => (state) => {
        if (state?.token) {
          localStorage.setItem('token', state.token)
          if (!document.cookie.match(/(^| )token=([^;]+)/)) {
            useUserStore.getState().setToken(state.token)
          }
        }
      },
    },
  ),
)

export type PageType = 'favorite' | 'follow'
interface PageState {
  favoritePageType: PageType
}
interface PageActions {
  setFavoritePageType: (page: PageType) => void
}
export const useUserPageStore = create<PageState & PageActions>()(
  persist(
    (set) => ({
      favoritePageType: 'favorite',
      setFavoritePageType: (page) => set({ favoritePageType: page }),
    }),
    {
      name: 'userPageStore',
    },
  ),
)
/*

store.setState((prev) => ({ obj: { count: prev.obj.count + 1 } }))

zustand state是不可变的   数据都是浅拷贝  可以使用immer 进行 深��贝
  immerInc: () => set(produce((state: State) => { ++state.deep.nested.obj.count }))
或者 
  opticsInc: () => set(O.modify(O.optic<State>().path("deep.nested.obj.count"))((c) => c + 1))
或者 
  ramdaInc: () => set(R.modifyPath(["deep", "nested", "obj", "count"], (c) => c + 1)),



/-------------  独立引用函数操作   共置操作和状态     ---------------
export const useBoundStore = create((set) => ({
  count: 0,
  text: 'hello',
  inc: () => set((state) => ({ count: state.count + 1 })),
  setText: (text) => set({ text }),
}))
export const useBoundStore = create(() => ({
  count: 0,
  text: 'hello',
}))

export const inc = () => useBoundStore.setState((state) => ({ count: state.count + 1 }))

export const setText = (text) => useBoundStore.setState({ text })

/-------------------------------------------------------------


/------------------------------ middlewares --------------------

const myMiddlewares = (f) => devtools(persist(f, { name: 'bearStore' }))

interface BearState {
  bears: number
  increase: (by: number) => void
}
const useBearStore = create<BearState>()(
  myMiddlewares((set) => ({
    bears: 0,
    increase: (by) => set((state) => ({ bears: state.bears + by })),
  })),
)
/------------------------------------------------------


/---------------------------   map和set数据的使用  -----------------
import { create } from 'zustand'

const useFooBar = create(() => ({ foo: new Map(), bar: new Set() }))

function doSomething() {

  useFooBar.setState((prev) => ({
    foo: new Map(prev.foo).set('newKey', 'newValue'),
    bar: new Set(prev.bar).add('newKey'),
  }))
}

/--------------------------状态重置-----------------------------

const initialState: State = {
  salmon: 0,
  tuna: 0,
}

const useSlice = create<State & Actions>()((set, get) => ({
  ...initialState,
  addSalmon: (qty: number) => {
    set({ salmon: get().salmon + qty })
  },
  addTuna: (qty: number) => {
    set({ tuna: get().tuna + qty })
  },
  reset: () => {
    set(initialState)
  },
}))
/--------------------------------------------------------------

/--------------------------------------------------------------

*/
